import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const EnterpriseAllDomainPage = loadOnRoute(
  () => import('bundles/enterprise-browse/components/EnterpriseAllDomainPage')
);
const EnterpriseDomainPage = loadOnRoute(() => import('bundles/enterprise-browse/components/EnterpriseDomainPage'));
const EnterpriseSkillPage = loadOnRoute(() => import('bundles/enterprise-browse/components/EnterpriseSkillPage'));
const EnterpriseSkillSetPage = loadOnRoute(() => import('bundles/enterprise-browse/components/EnterpriseSkillSetPage'));
const EnterpriseSkillSetSkillPage = loadOnRoute(
  () => import('bundles/enterprise-browse/components/EnterpriseSkillSetSkillPage')
);

export default (
  <CourseraRoute
    handle={{
      tracking: {
        data: (params) => ({
          page: { segment: 'enterprise', type: 'browse' },
          enterprise: {
            ...(params?.orgSlug ? { organizationSlug: params.orgSlug } : {}),
          },
        }),
      },
    }}
  >
    <Route path="/">
      <Route path="organizations/:orgSlug/browse" getComponent={EnterpriseAllDomainPage} />
      <Route path="organizations/:orgSlug/browse/:domainSlug" getComponent={EnterpriseDomainPage} />
      <Route path="organizations/:orgSlug/skills/:skillSlug" getComponent={EnterpriseSkillPage} />
      <Route path="organizations/:orgSlug/skillsets/:objectiveSlug" getComponent={EnterpriseSkillSetPage} />
      <Route
        path="organizations/:orgSlug/skillsets/:objectiveSlug/skill/:skillSlug"
        getComponent={EnterpriseSkillSetSkillPage}
      />
      {/* This catch-all *, status=404 route is important for SSR. */}
      <Route path="*" component={NotFound} />
    </Route>
  </CourseraRoute>
);
